import { ItemsClient } from './api-items';
import { EntitiesClient } from './api-entities';
import { ToolsClient } from './api-tools';

export class DfcApiClient {
  private _entitiesClient: EntitiesClient | null = null;
  private _itemsClient: ItemsClient | null = null;
  private _toolsClient: ToolsClient | null = null;

  get entities(): EntitiesClient {
    if (!this._entitiesClient) {
      this._entitiesClient = new EntitiesClient();
    }
    return this._entitiesClient;
  }

  get items(): ItemsClient {
    if (!this._itemsClient) {
      this._itemsClient = new ItemsClient();
    }
    return this._itemsClient;
  }

  get tools(): ToolsClient {
    if (!this._toolsClient) {
      this._toolsClient = new ToolsClient();
    }
    return this._toolsClient;
  }
}
